module.exports = "https://sf16-website.neutral.ttwstatic.com/obj/tiktok_web_static/bytecom/api_gateway_web_i18n/static/media/admin_type_4.0a0c8148.svg";